import React, { useState } from "react";
import api from "../../store/services/api";

import Avatar from "@mui/material/Avatar";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { red } from "@mui/material/colors";

export default function ChangePassword() {
  const [newPassword1, setNewPassword1] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [passOneLabel, setPassOneLabel] = useState("Nova Senha");
  const [passTwoLabel, setPassTwoLabel] = useState("Confirmar Nova Senha");
  const [helperText, setHelperText] = useState("");
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState([]);
  const [errorMessageOldPassword, setErrorMessageOldPassword] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessageOldPassword("");
    setErrorMessage([]);

    if (newPassword1 !== newPassword2) {
      setPassOneLabel("Erro");
      setPassTwoLabel("Erro");
      setHelperText("Senhas não são iguais");
      setIsError(true);
      return;
    }

    setIsError(false);

    const data = new FormData(e.currentTarget);

    try {
      const res = await api.put("/auth/user/change-password/", data);

      if (res.status === 200) {
        return (window.location.href = "/central-delivery");
      }
    } catch (e) {
      if (e.response.data?.old_password) {
        setErrorMessageOldPassword(e.response.data?.old_password[0]);
      }

      if (e.response.data?.non_field_errors) {
        setErrorMessage(e.response.data?.non_field_errors);
      }
    }
  };

  return (
    <Box
      sx={{
        m: "auto",
        width: "30%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Trocar Senha
      </Typography>
      <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="old_password"
          label="Senha Atual"
          type="password"
          name="old_password"
          autoFocus
        />
        <TextField
          error={isError}
          margin="normal"
          required
          fullWidth
          name="new_password1"
          label={passOneLabel}
          type="password"
          id="new_password1"
          helperText={helperText}
          onChange={(e) => {
            setNewPassword1(e.target.value);
          }}
        />
        <TextField
          error={isError}
          margin="normal"
          required
          fullWidth
          name="new_password2"
          label={passTwoLabel}
          type="password"
          id="new_password2"
          helperText={helperText}
          onChange={(e) => {
            setNewPassword2(e.target.value);
          }}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Trocar senha
        </Button>
      </Box>
      <Typography
        variant="body1"
        sx={{
          color: red[800],
        }}
      >
        {errorMessage.map((message) => {
          return message;
        })}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: red[800],
        }}
      >
        {errorMessageOldPassword}
      </Typography>
    </Box>
  );
}
